import React, { Suspense } from 'react'
import styled from 'styled-components'

import CardsSVG from '../../assets/credit-card.svg'
import CogsSVG from '../../assets/cogs.svg'
import ConverseSVG from '../../assets/converse.svg'
import HeartSVG from '../../assets/heart.svg'
import LightbulbSVG from '../../assets/lightbulb.svg'
import UsersSVG from '../../assets/users.svg'
import IDCardSVG from '../../assets/id-card.svg'
import EarthSVG from '../../assets/planet-earth.svg'

const images = {
    cards: <CardsSVG />,
    cogs: <CogsSVG />,
    converse: <ConverseSVG />,
    heart: <HeartSVG />,
    lightbulb: <LightbulbSVG />,
    users: <UsersSVG />,
    'id-card': <IDCardSVG />,
    'planet-earth': <EarthSVG />
}


export default ({ title, body, icon }) => {
    
    return (
        <Style>
            {images[icon]}
            <h4>{title}</h4>
            <p>{body}</p>
        </Style>
    )
}


const Style = styled.article.attrs(props => ({
    className: 'feature'
}))`

    > svg {
        max-width: 70px;
        max-height: 50px;
        height: auto;

        + h4 {
            margin-top: 1em;
        }
    }

    > h4 {
        font-size: 24px;
        letter-spacing: -0.84px;
        font-weight: 600;
        line-height: 1.1;
        margin-bottom: .5em;
    }

    > p {
        margin: 0;
        font-size: 14px;
        line-height: 1.4;
    }

`